import { useTranslation } from 'react-i18next'

import { useMermaid } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { GretaAIChatCodeBlock } from '../GretaAIChatCodeBlock'

import { QA_NAME_GRETA_AI_CHAT_MERMAID } from './GretaAIChatMermaid.constants'

import * as styles from './GretaAIChatMermaid.module.css'

function GretaAIChatMermaid({ code }) {
  const { t } = useTranslation()

  const { hasFailed, svg } = useMermaid(code)

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_MERMAID })

  return svg ? (
    <div
      {...qaProps}
      className={styles.diagram}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  ) : (
    <div {...qaProps} className={styles.fallback}>
      {hasFailed ? (
        <div className={styles.error}>{t('Greta.MermaidErrorKey')}</div>
      ) : null}

      <GretaAIChatCodeBlock className={styles.fallbackSource} code={code}>
        <code>{code}</code>
      </GretaAIChatCodeBlock>
    </div>
  )
}

export default GretaAIChatMermaid
